(function (ws) {
    'use strict';

    ws.views.modalTableProductRowView = Backbone.View.extend({
        tagName: 'tr',

        events: {
            'mousemove .qut-SAP-sba': 'showSBATooltip',
            'mouseout .qut-SAP-sba': 'hideSBATooltip'
        },

        /**
         * Initialize
         */
        initialize: function (options) {
            this.viewHelpers = options.viewHelpers || {};
            this.model = options.model;
            this.isDisabled = this.model.get('disable') === true ? 'disabled' : '';
            this.template = _.template(options.template.html());
            this.$tableContainer = options.$tableContainer;
        },

        /**
         * Render
         */
        render: function () {
            var model = this.model.toJSON();
            this.$el.addClass(model.rowClass);
            this.$el.addClass(this.isDisabled);
            this.$el.html(this.template(_.extend(model, this.viewHelpers)));

            return this;
        },

        /**
         * Show SBA tooltip
         * @param {Event} e
         */
        showSBATooltip: function (e) {
            var $tooltip = $(e.currentTarget).find('.qut-sba-tooltip');
            var top = $(e.currentTarget).offset().top - $(window).scrollTop();
            var left = e.clientX - 300;
            $tooltip.css({
                top: top,
                left: left
            });

            $tooltip.addClass('show');

        },

        /**
         * Hide SBA tooltip
         */
        hideSBATooltip: function (e) {
            var $tooltip = $(e.currentTarget).find('.qut-sba-tooltip');
            $tooltip.removeClass('show');
        }
    });
})(westcon);
